import { useMemo } from 'react'
import { OnboardingState } from '../../hooks/use-onboarding-setup'
import { OnboardingMode } from './types.d'

export const useDefaultSkipSetting = (onboardingInfo: OnboardingState): boolean => {
  return useMemo(() => onboardingInfo.onboardingMode === OnboardingMode.OnboardingViaWholesaler, [onboardingInfo])
}
